import ServiceTypesActionTypes from '../../Actions/Types/ActionTypes';

export const TypesReducer = (state = [], action) => {
    switch (action.type) {
        case ServiceTypesActionTypes.FETCH_TYPES:
            return action.payload;
            
        case ServiceTypesActionTypes.FETCH_TYPE:
            return [...state.filter(item => item.id !== action.payload.id), action.payload] 
            // return [...state, action.payload];
        
        case ServiceTypesActionTypes.ADD_TYPE:
            return [...state, action.payload];

        case ServiceTypesActionTypes.EDIT_TYPE:
            return [...state.filter(item => item.id !== action.payload.id), action.payload];

        case ServiceTypesActionTypes.DELETE_TYPE:
            return [...state.filter(item => item !== action.payload)];
            
        default:
            return state;
    }
}